module.exports = __webpack_public_path__ + "img/service01.f5b979aa.png";